export function isAngleTowardsRight(angle: number) {
    return angle < Math.PI / 2 && angle > -Math.PI / 2
}